
import { VSpacer } from "vuetify/lib";

export default VSpacer.extend({});
